export function SelectTicket(ticket) {
    return function(dispatch) {
        dispatch({
            type: 'TICKETS/SELECT',
            payload: {
                ticket: ticket,
            },
        });
    };
}

export function SelectTicketType(value) {
    return function(dispatch) {
        dispatch({
            type: 'TICKETS/SELECT_TYPE',
            payload: value,
        });
    };
}

export function AddTicket(ticket) {
    return function(dispatch) {
        dispatch({
            type: 'TICKETS/ADD_SINGLE',
            payload: {
                ticket: ticket,
            },
        });
    };
}

export function RemoveTicket(ticket) {
    return function(dispatch) {
        dispatch({
            type: 'TICKETS/REMOVE',
            payload: {
                ticket: ticket,
            },
        });
    };
}

export function ConfirmTickets(pkg, tickets) {
    return function(dispatch) {
        dispatch({
            type: 'TICKETS/CONFIRM',
            payload: {
                confirmed_package: pkg,
                confirmed_tickets: tickets,
            },
        });
    };
}

export function DeselectConfirmedTickets() {
    return function(dispatch) {
        dispatch({
            type: 'TICKETS/DESELECT_CONFIRMED_TICKETS',
        });
    };
}
